import { ImageTabs } from '../../../../../constants';
import { useGoogleAssetsImagesStore } from 'stores/GoogleAssets/GoogleAssetsImagesStore';

export const useImagesTab = () => {
  const store = useGoogleAssetsImagesStore();
  const handleImageTabChange = (tab: ImageTabs) => store.setActiveTab(tab);

  return { activeTab: store.activeTab, handleImageTabChange };
};
